// import { Routes, Route } from "react-router-dom";
// import AdminLogin from "../pages/admin/AdminLogin";
// import Dashboard from "../pages/admin/Dashboard";
// import AddJob from "../pages/admin/AddJob";
// import Applicants from "../pages/admin/Applicants";
// import JobLastings from "../pages/admin/JobLastings";
// // import Users from "../pages/admin/Users";
// import ProtectedRoute from "./ProtectedRoute";
// import AdminLayout from "../components/admin/AdminLayout";

// const AdminRoutes = () => {
//   return (
//     <Routes>
//       <Route path="/admin" element={<AdminLogin />} />

//       <Route
//         path="/admin/dashboard"
//         element={
//           <ProtectedRoute>
//             <AdminLayout>
//               <Dashboard />
//             </AdminLayout>
//           </ProtectedRoute>
//         }
//       />

//       <Route
//         path="/admin/careers"
//         element={
//           <ProtectedRoute>
//             <AdminLayout>
//               <AddJob />
//             </AdminLayout>
//           </ProtectedRoute>
//         }
//       />

//       <Route
//         path="/admin/job-listings"
//         element={
//           <ProtectedRoute>
//             <AdminLayout>
//               <JobLastings />
//             </AdminLayout>
//           </ProtectedRoute>
//         }
//       />

//       <Route
//         path="/admin/applicants"
//         element={
//           <ProtectedRoute>
//             <AdminLayout>
//               <Applicants />
//             </AdminLayout>
//           </ProtectedRoute>
//         }
//       />
//     </Routes>
//   );
// };

// export default AdminRoutes;
import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import AdminLayout from "../components/admin/AdminLayout";

import Dashboard from "../pages/admin/Dashboard";
import AddJob from "../pages/admin/AddJob";
import JobLastings from "../pages/admin/JobLastings";
import Applicants from "../pages/admin/Applicants";
import AdminLogin from "../pages/admin/AdminLogin";

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<AdminLogin />} />

      <Route
        path="dashboard"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <Dashboard />
            </AdminLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="careers"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <AddJob />
            </AdminLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="job-listings"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <JobLastings />
            </AdminLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="applicants"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <Applicants />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default AdminRoutes;